module.exports = __webpack_public_path__ + "pe.017a482a8e2647dc96de.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/1x1/pe.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/1x1/pe.svg
// module chunks = styles